<!-- src/components/Header.vue -->
<template>
  <header>
    <Navbar />
  </header>
</template>

<script>
import Navbar from "./Navbar";

export default {
  name: "Header",
  components: {
    Navbar,
  },
};
</script>
